import React, { memo } from 'react';
import styled from 'styled-components';
import backgroundImg from 'public/asset/about/00-main-visual/main-visual-img.png';
import { H1, SubtitleM } from 'global-styles';
import { useRouter } from 'next/router';
import { AboutLearnMoreArrow } from 'assets/icons';
import { scrollTo } from 'seamless-scroll-polyfill';
import Image from 'next/image';
import { generateCssStyle, mediaQueryStyle } from 'styles/breakPoints';
import {
  ImgBackgroundWrapper,
  MainVisualInnerContainer,
  MainVisualOuterContainer,
} from 'components/Common/CommonWrappers';
import { MainButton } from 'global-styles/MainButton';

const KO = () => (
  <div className="ko-wrapper">
    <SubtitleM>
      <div>
        블루닷은 시스템 반도체와 인공지능을 활용한 빠르고 지능적인 영상처리 및
        영상압축 기술을 클라우드 데이터 센터를 통해 서비스하는 벤처 회사입니다.
      </div>
    </SubtitleM>
  </div>
);

const EN = () => (
  <>
    <div className="en-wrapper-pc">
      <SubtitleM>
        <span>BLUEDOT is a startup that utilizes Semiconductor Design and</span>
      </SubtitleM>
      <SubtitleM>
        <span>Deep Learning to provide Fast and Intelligent Video</span>
      </SubtitleM>
      <SubtitleM>
        <span>
          Processing and Compression technologies through Cloud Data Center.
        </span>
      </SubtitleM>
    </div>
    <div className="en-wrapper-mo">
      <SubtitleM>
        <span>BLUEDOT is a startup that utilizes</span>
      </SubtitleM>
      <SubtitleM>
        <span>Semiconductor Design and</span>
      </SubtitleM>
      <SubtitleM>
        <span>Deep Learning to provide Fast and</span>
      </SubtitleM>
      <SubtitleM>
        <span>Intelligent Video Processing and</span>
      </SubtitleM>
      <SubtitleM>
        <span>Compression technologies through</span>
      </SubtitleM>
      <SubtitleM>
        <span>Cloud Data Center.</span>
      </SubtitleM>
    </div>
  </>
);

export const AboutMainVisual = memo(() => {
  const { locale } = useRouter();
  const handleClickLearnMore = () => {
    const $heightContainer = document.querySelector('.main-section-container');
    if ($heightContainer) {
      scrollTo(window, {
        top: $heightContainer.getBoundingClientRect().height,
        behavior: 'smooth',
      });
    }
  };
  //
  return (
    <AboutMainVisualContainer className="main-section-container">
      <ImgBackgroundWrapper>
        <Image
          src={backgroundImg.src}
          layout="fill"
          alt="About bluedot"
          className="target-img"
          objectFit="cover"
          sizes="(min-width: 906px) 90vw,
                 (min-width: 600px) 88vw,
                 (max-width: 599px) 80vw"
          loading="eager"
          quality={60}
          priority
        />
      </ImgBackgroundWrapper>

      <MainVisualInnerContainer>
        <H1 className="main-typo" as="h2">
          About <span>BLUEDOT</span>
        </H1>

        <div className="desc-text-wrapper">
          <div className="anim-wrapper">
            {locale === 'en' ? <EN /> : <KO />}
          </div>
        </div>

        <MainButton
          buttonType="default-w"
          icon={<AboutLearnMoreArrow />}
          iconPosition="right"
          injectCssStyles={[
            generateCssStyle({
              'margin-top': '32px',
              animation: `txtAnimation 0.8s 1.5s cubic-bezier(0.4, 0, 0.2, 1) backwards`,
            }),
            mediaQueryStyle.M`margin-top:56px;`,
          ]}
          injectInlineStyles={{ width: '328px', height: '56px' }}
          text={locale === 'en' ? 'Learn more' : '더 알아보기'}
          onClick={handleClickLearnMore}
        />
      </MainVisualInnerContainer>
    </AboutMainVisualContainer>
  );
});

AboutMainVisual.displayName = 'AboutMainVisual';

const AboutMainVisualContainer = styled(MainVisualOuterContainer)``;
